import Vue from 'vue'
import App from './App.vue'
import Cart from './Cart.vue'
import Orders from './Orders.vue'
import EditOrderItem from './components/EditOrderItem.vue'

Vue.config.productionTip = false

Vue.filter('currency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
  });
  return formatter.format(value);
});

Vue.prototype.$defaults = {
  billingAddress: undefined
}
/* global billingAddressDefaults */
if (typeof billingAddressDefaults !== 'undefined') {
  /* global billingAddressDefaults */
  Vue.prototype.$defaults.billingAddress = billingAddressDefaults
}

new Vue({
  render: h => h(App),
}).$mount('#sms-shop-app')

new Vue({
  render: h => h(Cart),
}).$mount('#sms-shop-cart')

new Vue({
  render: h => h(Orders),
}).$mount('#sms-shop-orders')

new Vue({
  render: h => h(EditOrderItem),
}).$mount('#sms-shop-edit-order-item')
